import { mapGetters } from "vuex";
const qs = require("qs");
import toast from "../../components/mixin/toast";

// import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import { LogoutMixins } from "../login/LogoutMixins";
import Loader from "../../components/fixedcomponents/Loader.vue";
import ReportModal from "./ReportModal.vue";

import {
  getDeviceActivity,
  getProfileInfo,
  signOutAllDevices,
  getProfileDetails,
  userLogin,
  resetPassword,
  signOutDevices,
  raiseQuery,
  getTicketHistory,
} from "../../utils/apiFunctions";

const accountSettingsMixins = {
  name: "interviewProcessMixins",
  components: {
    Loader,
    ReportModal,
  },
  mixins: [toast, LogoutMixins],

  data: () => ({
    ticketHistory: {},
    ticketInfo: {},
    showTicketInfoModal: false,
    showReportModal: false,

    queryLoader: false,
    showConcern: false,
    showQuery: false,
    saveProfile: false,
    profileLoader: false,
    pswLoader: false,
    deviceLoader: false,
    showMainPage: false,
    showForm: false,
    changePassword: false,
    showAllSwitch: false,
    showAllDevices: false,
    showPassword: false,
    allowScrollHandling: true,
    showDeviceActivityShimmer: false,
    showDataShimmer: false,
    showActivityShimmer: false,
    sections: ["personalData", "basicAuth", "deviceActivity", "query"],

    allSessions: [],
    loopvar: 4,
    maxCharacters: 200,
    linkCopied: false,
    currentlyTrue: {},
    deviceSignOut: false,
    concern: "",
    selectedDevice: null,
    activeTab: "personalData",
    ticketId: null,
    showCurrentPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    matchCriteria: false,
    tabIndex: 0,
    selected: [],
    device: [],
    savedAuthentication: false,
    editProfile: false,
    raiseQuery: false,
    // Variables to show or hide different containers/sections
    showProfInfo: false, // Show Profile Info
    showBasicAut: false, // Show Basic Authentication
    resetPassword: false, // Flag for resetting password
    showDevAct: false, // Show Device Activity
    showApp: false, // Show Application
    checkCurrentPsw: false,
    checkNewPsw: false,

    checkConfirmPsw: false,

    // Form fields for password reset
    passwordDetails: {
      currentPassword: "",
      newPswd: "",
      confirmPswd: "",
    },

    // Profile related fields
    profileDetails: {
      email: "",
      firstName: "",
      lastName: "",
    },
    reassignDetails: {
      firstName: "",
      lastName: "",
    },

    hasUppercase: false,
    passwordsMatch: false,
    hasLowercase: false,
    hasSplcharacter: false,
    hasNumber: false,
    showPersonalDataShimmer: false,

    // Arrays to store device activity and application data
    getApplication: [],
  }),

  computed: {
    charactersLeft() {
      return this.maxCharacters - this.concern.length;
    },
    // Mapping Vuex getters to computed properties
    ...mapGetters("userVUEX", {
      User: "getRoleValues", // Get user role values
    }),
  },

  validations: {
    // Validation rules for form fields
    profileDetails: {
      firstName: {
        required,
        maxLength: (value) => maxLength(38)(value.replace(/\s+/g, "")),
        alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
      },

      lastName: {
        required,
        maxLength: (value) => maxLength(38)(value.replace(/\s+/g, "")),

        alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
      },
    },
    passwordDetails: {
      confirmPswd: {
        required,
        maxLength: maxLength(55),
      },
      newPswd: {
        required,
        maxLength: maxLength(55),
      },
      currentPassword: {
        required,
        maxLength: maxLength(55),
      },
    },
    concern: {
      required,
    },
  },
  watch: {
    "passwordDetails.currentPassword": function () {
      this.checkCurrentPsw = false;

      if (
        this.passwordDetails.newPswd != this.passwordDetails.currentPassword
      ) {
        this.checkNewPsw = true;
      } else {
        this.checkNewPsw = false;
      }
    },

    "passwordDetails.confirmPswd": function () {
      if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
        this.passwordsMatch = true;
      } else {
        this.passwordsMatch = false;
      }
    },

    "passwordDetails.newPswd": function () {
      this.matchCriteria = false;

      if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
        this.passwordsMatch = true;
      } else {
        this.passwordsMatch = false;
      }
      if (
        this.passwordDetails.newPswd != this.passwordDetails.currentPassword
      ) {
        this.checkNewPsw = true;
      } else {
        this.checkNewPsw = false;
      }
    },
  },
  methods: {
    showTicketInfo(ticket) {
      this.showTicketInfoModal = true;
      this.ticketInfo = ticket;
    },
    closedActivity(ticket) {
      if (!ticket || !ticket.activity) return null;

      const reversed = [...ticket.activity].reverse();
      return reversed.find((item) => item.status == "5") || null;
    },
    formatDate(date) {
      if (!date) return "";
      if (date.includes(",")) {
        return date.slice(0, date.indexOf(","));
      }
      return date.slice(0, 10);
    },
    async getTicketHistory() {
      try {
        const res = await getTicketHistory();
        if (res.status == 200) {
          this.ticketHistory = res.data.data;
          console.log("ticketHistory", this.ticketHistory);
        }
      } catch (e) {
        console.log(e);
      }
    },
    removeSpace(field) {
      this.profileDetails[field] = this.profileDetails[field].trim();
    },
    editPersonalData() {
      this.$v.profileDetails.$touch();

      this.editProfile = true;
      this.reassignDetails = JSON.parse(JSON.stringify(this.profileDetails));
    },
    reassignPersonalDetails() {
      this.profileDetails = { ...this.reassignDetails };
    },
    alphabetsOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        (charCode < 65 || charCode > 90) &&
        (charCode < 97 || charCode > 122) &&
        charCode !== 32 && // space
        charCode !== 46 // dot
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    copyTheLink(ticketId) {
      const textToCopy = ticketId;

      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.linkCopied = true;
          setTimeout(() => {
            this.linkCopied = false;
          }, 3000); // 3000 milliseconds = 3 seconds
        })
        .catch((err) => {
          console.error("Error in copying text: ", err);
        });
    },

    async raiseQueries() {
      this.$v.concern.$touch();
      if (!this.$v.concern.$invalid) {
        this.queryLoader = true;
        let payload = {
          concern: this.concern,
        };

        const res = await raiseQuery(payload);

        if (res.status == 200) {
          this.queryLoader = false;
          this.$bvModal.show("submitQuery");

          this.raiseQuery = false;
          this.ticketId = res.data.data.ticketID;
        }
      }
    },
    logout() {
      localStorage.clear();
      this.$store.dispatch("userVUEX/LogOut");
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
      location.reload();
    },
    closeSignout() {
      this.$bvModal.hide("signOutModal");
      this.selectedDevice = null;
    },
    async signOut(j) {
      this.deviceLoader = true;
      try {
        let payload = {
          id: j.id,
        };

        const res = await signOutDevices(payload); // Call the API to sign out of the specific device
        if (res.status == 200) {
          this.$bvModal.hide("signOutModal");

          if (j.current == true) {
            this.logout();
          } else {
            this.getDeviceActivity();
          }

          this.selectedDevice = null;
        }
      } catch (error) {
        this.errorModal("An error occurred"); // Show error toast
        console.error("Error:", error); // Log the error to the console
      }
    },
    signOutConfirm(j) {
      this.selectedDevice = j;

      this.$bvModal.show("signOutModal");
    },
    togglePasswordVisibility(field) {
      this[field] = !this[field];
    },
    validatePassword() {
      this.hasUppercase = /^(.*[A-Z]){1,}.*$/.test(
        this.passwordDetails.newPswd
      );
      this.hasLowercase = /^(?=.*[a-z])/.test(this.passwordDetails.newPswd);
      this.hasSplcharacter = /^(.*[!@#$%^&*()_+{}[\]:;<>,.?~\\/-]){1,}.*$/.test(
        this.passwordDetails.newPswd
      );
      this.hasNumber = /^(.*\d){1,}.*$/.test(this.passwordDetails.newPswd);
    },

    resetpasswordfields() {
      // this.savedAuthentication = false;
      this.showCurrentPassword = false;
      this.showNewPassword = false;
      this.passwordDetails.newPswd = "";
      this.passwordDetails.currentPassword = "";

      this.passwordDetails.confirmPswd = "";
      this.hasUppercase = false;
      this.hasLowercase = false;
      this.hasSplcharacter = false;
      this.hasNumber = false;
      this.matchCriteria = false;
      this.$v.passwordDetails.$reset();
    },

    cancelResetPswd() {
      // this.savedAuthentication = true;

      this.$v.passwordDetails.$reset();
      // this.resetPassword = false;
      this.passwordDetails.currentPassword = "";
      this.passwordDetails.newPswd = "";
      this.hasUppercase = false;
      this.hasLowercase = false;
      this.hasSplcharacter = false;
      this.hasNumber = false;
      this.matchCriteria = false;

      this.passwordDetails.confirmPswd = "";
    },
    // Method to reset the password
    async resetPwd() {
      try {
        // Validate form fields
        this.$v.passwordDetails.$touch();

        // Set loading status to true
        if (
          this.passwordDetails.confirmPswd != "" &&
          this.passwordDetails.newPswd != "" &&
          (!this.hasUppercase ||
            !this.hasLowercase ||
            !this.hasNumber ||
            !this.hasSplcharacter)
        ) {
          this.matchCriteria = true;
        } else if (
          this.passwordDetails.confirmPswd != "" &&
          this.passwordDetails.newPswd != "" &&
          this.hasUppercase &&
          this.hasLowercase &&
          this.hasNumber &&
          this.hasSplcharacter
        ) {
          this.matchCriteria = false;
        }

        if (
          this.passwordDetails.newPswd != this.passwordDetails.currentPassword
        ) {
          this.checkNewPsw = true;
        } else {
          this.checkNewPsw = false;
        }

        // Check if form fields are not invalid

        if (
          !this.$v.passwordDetails.$invalid &&
          this.passwordsMatch == true &&
          this.hasUppercase == true &&
          this.hasLowercase == true &&
          this.hasSplcharacter == true &&
          this.hasNumber == true &&
          this.matchCriteria == false
        ) {
          // Extract password from Keycloak string

          let username = this.User.email;
          let payload = qs.stringify({
            grant_type: "password",
            client_id: "vue-test-app",
            username: username,
            password: this.passwordDetails.currentPassword,
          });
          this.pswLoader = true;

          // Send user login request
          const response = await userLogin(payload);

          if (response.status == 200) {
            // If login successful, prepare payload to reset password
            let userpayload = {
              email: username,
              password: this.passwordDetails.confirmPswd,
            };
            // Call the API to reset the password
            const res = await resetPassword(userpayload);
            if (res.status == 200) {
              this.pswLoader = false;
              (this.changePassword = false), (this.showPassword = true);
              this.$v.$reset();
              this.resetPassword = false; // Set resetPassword flag to false
              this.successModal("Password reset successful!"); // Show success toast
              this.savedAuthentication = true; // Set saved authentication
              this.passwordDetails.currentPassword = "";
              this.passwordDetails.newPswd = "";

              this.passwordDetails.confirmPswd = "";
            } else if (res.status == 401) {
              this.checkCurrentPsw = true;
              this.pswLoader = false;

              this.errorModal("Something went wrong"); // Show error toast
            }
          }
        }
      } catch (error) {
        this.checkCurrentPsw = true;
        this.pswLoader = false;

        console.error("Error:", error); // Log the error to the console
      }
    },

    // Method to fetch profile details
    async getprofileDetails() {
      try {
        let payload = {
          email: this.User.email,
        };
        // Call the API to get profile details
        const res = await getProfileDetails(payload);
        if (res.status == 200) {
          this.showDataShimmer = false;
          // Set email, firstName, and lastName based on API response
          this.profileDetails = {
            email: res.data.data[0].EMAIL,
            firstName: res.data.data[0].FIRST_NAME,
            lastName: res.data.data[0].LAST_NAME,
          };
          // Create a copy of profileDetails for reassignment later
          this.reassignDetails = { ...this.profileDetails };
        }
      } catch (error) {
        this.errorModal("An error occurred"); // Show error toast
        console.error("Error:", error); // Log the error to the console
      }
    },

    // Method to update the profile
    async getProfile() {
      try {
        this.$v.profileDetails.$touch();

        // Check if form fields are not invalid
        if (!this.$v.profileDetails.$invalid) {
          this.profileLoader = true;
          this.saveProfile = true;

          // Call the API to update the profile
          const res = await getProfileInfo(this.profileDetails);

          if (res.status == 200) {
            this.reassignDetails = this.profileDetails;
            this.profileLoader = false;
            this.saveProfile = false;

            this.editProfile = false;
            this.successModal("Profile updated successfully"); // Show success toast
          } else {
            this.errorModal("Something went wrong"); // Show error toast
          }
        } else if (
          this.profileDetails.firstName == "" ||
          this.profileDetails.lastName == ""
        ) {
          this.errorModal("Please fill all the fields"); // Show error toast for incomplete fields
        }
      } catch (error) {
        this.errorModal("An error occurred while updating the profile"); // Show error toast
        console.error("Error:", error); // Log the error to the console
      }
    },

    // Method to format a timestamp
    formatTimestamp(timestamp) {
      // Convert timestamp to a Date object
      const dateObj = new Date(timestamp * 1000);
      // Extract the date components
      const day = String(dateObj.getDate()).padStart(2, "0");
      const month = String(dateObj.getMonth() + 1).padStart(2, "0");
      const year = String(dateObj.getFullYear());
      // Extract the time components
      let hours = dateObj.getHours();
      let minutes = dateObj.getMinutes();
      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12;
      hours = String(hours).padStart(2, "0");
      minutes = String(minutes).padStart(2, "0");
      // Concatenate the date and time parts with "at"
      const formattedDateTime = `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
      return formattedDateTime; // Return the formatted date and time
    },

    // Method to sign out of all devices
    async signOutAllDevices() {
      this.deviceLoader = true;
      const res = await signOutAllDevices(); // Call the API to sign out all devices
      if (res.status == 200) {
        this.deviceLoader = false;
        this.$bvModal.hide("signOutModal");
        this.$bvModal.show("signedout");
        this.getDeviceActivity();
      }
    },

    async getDeviceActivity() {
      try {
        const response = await getDeviceActivity(this.profileDetails);
        if (response.status === 200) {
          this.showPersonalDataShimmer = false;
          this.showActivityShimmer = false;
        }
        this.device = response.data;
        this.device.forEach((deviceItem) => {
          const sessions = deviceItem.sessions;
          this.allSessions = sessions.filter((session) => !session.current);

          const currentSession = sessions.find((session) => session.current);
          if (currentSession) {
            // Store the current session in the device object
            this.currentlyTrue = { ...currentSession };
            this.currentlyTrue.lastAccess = this.formatTimestamp(
              this.currentlyTrue.lastAccess
            );
            this.currentlyTrue.started = this.formatTimestamp(
              this.currentlyTrue.started
            );
            this.currentlyTrue.expires = this.formatTimestamp(
              this.currentlyTrue.expires
            );
          }

          sessions.forEach((session) => {
            // Format timestamps if needed
            session.lastAccess = this.formatTimestamp(session.lastAccess);
            session.started = this.formatTimestamp(session.started);
            session.expires = this.formatTimestamp(session.expires);
          });
        });
        this.deviceLoader = false;
      } catch (error) {
        this.errorModal("Error", "An error occurred");
      }
    },
    // Methods to show/hide different sections of the profile
    showBasicAuth() {
      this.showBasicAut = true;
      this.showProfInfo = false;
      this.showDevAct = false;
      this.showApp = false;
    },
    showProfile() {
      this.showProfInfo = true;
      this.showDevAct = false;
      this.showBasicAut = false;
      this.showApp = false;
    },
    showDevice() {
      this.showDevAct = true;
      this.showBasicAut = false;
      this.showProfInfo = false;
      this.showApp = false;
    },
    showApplication() {
      this.showApp = true;
      this.showDevAct = false;
      this.showBasicAut = false;
      this.showProfInfo = false;
    },
  },
};
export default accountSettingsMixins;
